import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case05.technical-details-slide";
export const messages = defineMessages({
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem1Description: {
    id: `${PREFIX}.accordion-item1.description`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem2Description: {
    id: `${PREFIX}.accordion-item2.description`,
  },
  readMore: {
    id: `${PREFIX}.read-more`,
  },
  mainSystemTitle: {
    id: `${PREFIX}.main-system-title`,
  },
  mainSystemDescription: {
    id: `${PREFIX}.main-system-description`,
  },
  mainSystemImageDescription: {
    id: `${PREFIX}.main-system-image-description`,
  },
  LFETitle: {
    id: `${PREFIX}.lfe-title`,
  },
  LFEDescription: {
    id: `${PREFIX}.lfe-description`,
  },
  LFEImageDescription: {
    id: `${PREFIX}.lfe-image-description`,
  },
  CeilingSystemTitle: {
    id: `${PREFIX}.ceiling-system-title`,
  },
  CeilingSystemDescription: {
    id: `${PREFIX}.ceiling-system-description`,
  },
  CeilingSystemImageDescription: {
    id: `${PREFIX}.ceiling-system-image-description`,
  },
  FrontFillsTitle: {
    id: `${PREFIX}.front-fills-title`,
  },
  FrontFillsDescription: {
    id: `${PREFIX}.front-fills-description`,
  },
  FrontFillsImageDescription: {
    id: `${PREFIX}.front-fills-image-description`,
  },
  SignalFlowTitle: {
    id: `${PREFIX}.signal-flow-title`,
  },
  SignalFlowImageTitle: {
    id: `${PREFIX}.signal-flow-image-title`,
  },
  SignalFlowDescription: {
    id: `${PREFIX}.signal-flow-description`,
  },
  SignalFlowModalTitle: {
    id: `${PREFIX}.signal-flow-modal.title`,
  },
  SignalFlowModalDescription: {
    id: `${PREFIX}.signal-flow-modal.description`,
  },
});
